import { c as _c } from "react/compiler-runtime";
import { Collapsible, Flex, TextBody } from "@opensea/ui-kit";
import { Error } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { SwapWarningDetail } from "./SwapWarningDetail";
export function SwapWarning(t0) {
  const $ = _c(15);
  const {
    warnings,
    symbol
  } = t0;
  const t = useTranslations("wallet.SwapWarning");
  if (warnings.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== t || $[1] !== warnings) {
    let t2;
    if ($[3] !== t) {
      t2 = featureId => <SwapWarningDetail description={t(`${featureId}.description`)} key={featureId} title={t(`${featureId}.title`)} />;
      $[3] = t;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = warnings.map(t2);
    $[0] = t;
    $[1] = warnings;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="rounded-sm border border-legendary bg-caution-transparent-1 p-0.5"><Error fill="caution" size={16} /></div>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== symbol || $[7] !== t || $[8] !== warnings.length) {
    t3 = t("title", {
      count: warnings.length,
      symbol
    });
    $[6] = symbol;
    $[7] = t;
    $[8] = warnings.length;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <Flex className="items-center gap-2">{t2}<TextBody size="sm">{t3}</TextBody></Flex>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t4) {
    t5 = <div className="p-4"><Collapsible className="w-full" content={t1}>{t4}</Collapsible></div>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}